<template>
  <div>
    <div class="invoice">
      <div class="invoiceBox clearfix">
        <img src="../../../../assets/kpxxewm.png" alt="">
        <div class="topBox">
          <p>开票信息</p>
        </div>
        <div class="btnBox">
          <p>名称：南京华晟医学检验实验室有限公司</p>
          <p>纳税人识别号：91320115MA1P86AL7X</p>
          <p>地址电话：南京市江宁区秣陵街道乾德路2号2幢2层西侧（江宁</p>
          <p>高新园）025-86163626</p>
          <p>开户行及账号：工商银行南京天元支行 4301097309000047248</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.invoice {
  width: 100%;
  height: 804px;
  position: relative;
  .invoiceBox {
    width: 1525px;
    height: 601px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background-color: #e5f0f8;
    img {
      width: 324px;
      height: 324px;
      // border: 1px dashed #000;
      position: absolute;
      top: 172px;
      left: 223px;
    }
    .topBox {
      width: 141px;
      height: 34px;
      line-height: 34px;
      position: absolute;
      top: 74px;
      right: 694px;
      text-align: center;
      p {
        font-size: 34px;
        color: #237cc0;
      }
    }
    .btnBox {
      width: 663px;
      height: 287px;
      position: absolute;
      top: 203px;
      right: 235px;
      // background-color: skyblue;
      p {
        font-size: 23px;
        margin-bottom: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/website/contact/component/invoice.vue